// src/components/QuickLookModal.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom";

export default function QuickLookModal({
  open,
  onClose,
  children,
  // These are maximums; on mobile we clamp to viewport.
  width = 880,
  height = 560,
  title = "Preview",
}) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2000,
        backdropFilter: "blur(1.5px)",
        // allow scrolling if very small screens
        overflow: "auto",
        padding: 12,
      }}
    >
      <div
        style={{
          width: `min(${width}px, 96vw)`,
          height: `min(${height}px, 86vh)`,
          background: "#0f0f0f",
          border: "1px solid #272727",
          borderRadius: 14,
          boxShadow: "0 30px 90px rgba(0,0,0,0.5)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            height: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            borderBottom: "1px solid #222",
            color: "#ddd",
            gap: 12,
          }}
        >
          <div style={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis" }}>{title}</div>
          <button
            onClick={onClose}
            aria-label="Close"
            style={{
              background: "#1c1c1c",
              color: "#ddd",
              border: "1px solid #333",
              borderRadius: 8,
              padding: "6px 10px",
              fontSize: 12,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ flex: 1, minHeight: 0 }}>
          {/* Pass the actual pixel size to the chart so it lays out exactly */}
          {React.isValidElement(children)
            ? React.cloneElement(children, {
                width: Math.min(width, window.innerWidth * 0.96),
                height: Math.min(height, window.innerHeight * 0.86),
              })
            : children}
        </div>
      </div>
    </div>,
    document.body
  );
}
